import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { Link } from "react-router-dom";
import { getData, putData } from "../../FetchNodeServices";
import { useSelector } from "react-redux";
import Select from "react-select";
import { InfinitySpin } from "react-loader-spinner";
import AlertMessages from "../Mains/Alerts";

const BillingDetail = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullwidthwrapper, setFullwidthwrapper] = useState();
  const [isDataChanged, setDataChanged] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [companyDomain, setCompanyDomain] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  // const [countryName, setCountryName] = useState("");
  const [countryId, setCountryId] = React.useState("");
  const [stateId, setStateId] = React.useState("");
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");
  const [accountId, setAccountId] = useState("");
  const customer = useSelector((state) => state.user.users[0]);
  const user = customer.userId;
  const [isLoading, setIsLoading] = useState(true);
  const [alerts, setAlerts] = useState([]);

  const handleToggle = () => {
    setIsActivated(!isActivated);
    setFullwidthwrapper(isActivated ? "fullwrapper" : "");
  };
  const userRole = localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).userRole;

  const fetchCustomerAdmins = async () => {
    let result = await getData("users/billing-details/" + user);
    if (result) {
      setAccountId(result.accountId);
      setCompanyName(result.companyName);
      setCompanyDomain(result.companyDomain);
      setCompanyAddress(result.companyAddressLineOne);
      // fetchState(result.countryId);
      setCountryId(result.country);
      setStateId(result.state);
      setCity(result.city);
      setPincode(result.zipcode);
      fetchState(result.country);
      setIsLoading(false);
    }
  };
  useEffect(function () {
    fetchCustomerAdmins();
  }, []);

  const handleCountryChange = (selectedOption) => {
    setCountryId(selectedOption.value);

    fetchState(selectedOption.value);
    setDataChanged(true);

    // alert(selectedOption.value);
  };

  const fetchCountry = async () => {
    setIsLoading(true);
    let result = await getData("users/country");
    setCountryList(result);
    setIsLoading(false);
  };
  useEffect(function () {
    fetchCountry();
  }, []);

  // const fillCountry = () => {
  //   return countryList.map((item) => {
  //     return <option key={item.countryId} value={item.countryId} />;
  //   });
  // };

  const fillCountry = () => {
    return countryList.map((item) => {
      return { value: item.countryId, label: item.countryName };
    });
  };

  // console.log(fillCountry());

  const fetchState = async (countryId) => {
    setIsLoading(true);

    var result = await getData("users/country/state-list/" + countryId);
    setStateList(result);
    setIsLoading(false);
  };

  const fillState = () => {
    if (!Array.isArray(stateList)) {
      return [];
    }
    return stateList.map((item) => {
      return { value: item.stateName, label: item.stateName };
      //   <option key={item.stateId} value={item.stateId}>
      //     {item.stateName}
      //   </option>
      // );
    });
    // }
  };

  const handleStateChange = (selectedOption) => {
    setStateId(selectedOption.value);
    setDataChanged(true);

    // fetchState(event.target.value);
  };

  const handleInputChange = (event, setter) => {
    setter(event.target.value);
    setDataChanged(true);
  };

  const handleSubmit = async () => {
    if (!isDataChanged) return;
    setIsLoading(true);
    var FormData = {
      userId: user,
      accountId: accountId,
      companyName: companyName,
      companyDomain: companyDomain,
      companyAddressLineOne: companyAddress,
      country: countryId,
      state: stateId,
      city: city,
      zipcode: pincode,
    };
    var result = await putData("users/billing-details", FormData);
    if (result) {
      // alert("User updated Successfully!");
      setAlerts([{ variant: "success", heading: "User updated Successfully!." }]);

      setIsLoading(false);
    } else {
      // alert("Something went wrong!");
      setAlerts([{ variant: "danger", heading: "Something went wrong!" }]);
    }
  };

  // const handleClear = () => {
  //   fetchCustomerAdmins();
  //   setDataChanged(false);
  // };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />
        {isLoading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center " style={{ zIndex: 1050 }}>
            <div className="p-5 rounded ">
              <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
            </div>
          </div>
        )}
        <div id="page_wrapper" className={`py-3 ${isLoading ? "blur" : ""}`}>
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <Link to="/manage-customer">
                <li>
                  <i className="bi bi-people"></i> Customer
                </li>
              </Link>
              <span className="breadcrumb_slash">/</span>
              <Link to="/manage-customer">
                <li>
                  <i className="bi bi-app-indicator mx-2"></i> Manage Customer
                </li>
              </Link>
              <span className="breadcrumb_slash">/</span>
              <li>
                <i className="bi bi-pencil-square mx-2"></i>Edit Billing Details
              </li>
            </ul>
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 1050 }}>
              <AlertMessages alerts={alerts} setAlerts={setAlerts} />
            </div>
          </div>
          <div className="steps_box mb-3 fw-600">
            <Link to="/ebasic-detail">
              <div>
                <span className="step_count">1</span>Edit Basic Details
              </div>
            </Link>
            <i className="bi bi-chevron-right mx-3 fs-12"></i>
            <div>
              <span className="step_count active">2</span>Edit Billing Details
            </div>
            <i className="bi bi-chevron-right mx-3 fs-12"></i>
            <Link to="/ebranding">
              <div>
                <span className="step_count">3</span>Edit Branding
              </div>
            </Link>
          </div>

          <div className="card p-3 border-light-subtle">
            <div className="common_form p-3">
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">Company Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={companyName}
                      placeholder="Please enter registered legal name for billing"
                      onChange={(event) => handleInputChange(event, setCompanyName)}
                      readOnly={userRole === "U"}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">Company Domain</label>
                    <input
                      type="text"
                      className="form-control"
                      value={companyDomain}
                      placeholder="Enter Company Domain"
                      readOnly={userRole === "U"}
                      onChange={(event) => handleInputChange(event, setCompanyDomain)}
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">Company Address</label>
                    <input
                      type="text"
                      className="form-control"
                      value={companyAddress}
                      placeholder="Enter Address"
                      readOnly={userRole === "U"}
                      onChange={(event) => handleInputChange(event, setCompanyAddress)}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">City</label>
                    <input
                      type="text"
                      className="form-control"
                      value={city}
                      placeholder="Enter City"
                      onChange={(event) => handleInputChange(event, setCity)}
                      readOnly={userRole === "U"}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">Country</label>
                    {/* <input
                      type="text"
                      list="countrydatalist"
                      id="country"
                      value={countryId}
                      className="form-control"
                      placeholder="Enter country"
                      onChange={(event) => handleCountryChange(event)}
                    /> */}
                    <Select
                      options={fillCountry()}
                      value={fillCountry().find((option) => option.value === countryId)}
                      onChange={handleCountryChange}
                      placeholder="Enter country"
                      isSearchable
                      isDisabled={userRole === "U"}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">State</label>
                    {/* <input
                      type="text"
                      list="statelist"
                      className="form-control"
                      value={stateId}
                      placeholder="Enter state"
                      onChange={(event) => handleStateChange(event)}
                    />
                    <datalist id="statelist">
                      {fillState()}
                      {/* <option value="Uttar Pradesh" /> */}
                    {/* <Select
                      options={fillState()}
                      value={fillState().find((option) => option.value === stateId)}
                      onChange={handleStateChange}
                      placeholder="Enter State"
                      isDisabled={userRole === "U"}
                      isSearchable
                    /> */}
                    {stateList.length === 0 ? (
                      <input
                        type="text"
                        id="state"
                        className="form-control "
                        placeholder="Enter state"
                        value={stateId}
                        onChange={(e) => setStateId(e.target.value)}
                      />
                    ) : (
                      <Select
                        options={fillState()}
                        value={fillState().find((option) => option.value == stateId)}
                        onChange={(selectedOption) => handleStateChange(selectedOption)}
                        placeholder="Enter State"
                        isSearchable
                      />
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label for="">PIN Code</label>
                    <input
                      type="text"
                      className="form-control"
                      value={pincode}
                      placeholder="Enter pincode"
                      onChange={(event) => handleInputChange(event, setPincode)}
                      readOnly={userRole === "U"}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-between">
                <div className="button_group">
                  <Link to="/ebasic-detail">
                    <button type="button" className="btn btn-light text-grey me-3">
                      <i className="bi bi-chevron-left me-1"></i> Back
                    </button>
                  </Link>
                  {/* <button type="button" className="btn bg-danger-subtle text-danger" onClick={() => handleClear()}>
                    Clear Values
                  </button> */}
                </div>
                <div className="button_group">
                  <Link to="/ebranding">
                    <button type="button" className="btn btn-success px-4" onClick={() => handleSubmit()}>
                      {isDataChanged ? "Update" : "Next"}
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingDetail;
